import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from '@phosphor-icons/react';

const resolveImg = (src) => {
  if (!src) return 'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?w=800';
  return src;
};

const BlogPreview = ({ posts }) => {
  return (
    <section className="py-16 sm:py-24 bg-muted/30" data-testid="blog-preview-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end gap-4 mb-8 sm:mb-12">
          <div className="min-w-0">
            <span className="overline text-primary mb-2 sm:mb-4 block">From the Blog</span>
            <h2 className="font-serif text-3xl sm:text-4xl text-primary">
              Wine Country Guides
            </h2>
          </div>
          <Link 
            to="/blog" 
            className="text-primary hover:underline inline-flex items-center gap-1 font-medium self-start sm:self-auto"
            data-testid="view-all-blog-link"
          >
            Read More <ArrowRight size={16} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {posts.slice(0, 3).map((post, index) => (
            <motion.article
              key={post.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="min-w-0"
            >
              <Link 
                to={`/blog/${post.slug}`}
                className="group block"
                data-testid={`blog-card-${post.slug}`}
              >
                <div className="aspect-[16/9] overflow-hidden rounded-lg mb-4 bg-muted">
                  <img
                    src={resolveImg(post.featured_image)}
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="eager"
                    referrerPolicy="no-referrer"
                  />
                </div>
                <span className="text-xs text-gold-600 font-medium uppercase tracking-wide">
                  {post.category}
                </span>
                <h3 className="font-serif text-xl text-primary mt-2 mb-2 group-hover:text-primary/80 transition-colors">
                  {post.title}
                </h3>
                <p className="text-muted-foreground text-sm line-clamp-2">
                  {post.excerpt}
                </p>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
